import { ClientCards } from 'components/landingPageComponents/testimonialSection/ClientCards'
import { tenant_logo_url } from 'context/AuthContext'
import { useAppContext } from 'context/AppContext'
import { useEffect, useRef } from 'react'
import CanonicalLink from 'components/PageHeaders/CanonicalLink'
import dynamic from 'next/dynamic'
import EmailVerificationModal from 'components/Modals/EmailVerification'
import Head from 'next/head'
import LoginModal from 'components/Modals/Login'
import SignupModal from 'components/Modals/Signup'
import AwardSection from 'components/landingPageComponents/awardSection/AwardSection'
import getConfig from 'next/config'

const Footer = dynamic(() => import('../components/Footer'))
const Navbar = dynamic(() => import('../components/Navbar'))
const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

const LandingSectionTryCTA = dynamic(
    () => import('../components/Landing/section-try-cta')
)
const LandingPartnersSection = dynamic(
    () => import('../components/Landing/section-partners')
)
const SecondSection = dynamic(
    () =>
        import(
            'components/landingPageComponents/secondSection/SecondSection'
        )
)
const ThirdSection = dynamic(
    () =>
        import('components/landingPageComponents/thirdSection/ThirdSection')
)
const FourthSection = dynamic(
    () =>
        import(
            'components/landingPageComponents/fourthSection/FourthSection'
        )
)
const FeaturesListSection = dynamic(
    () =>
        import(
            'components/landingPageComponents/featuresListSection/FeaturesListSection'
        )
)
const TeamSection = dynamic(
    () => import('components/landingPageComponents/TeamSection/TeamSection')
)
const GallerySection = dynamic(
    () =>
        import(
            'components/landingPageComponents/gallerySection/GallerySection'
        )
)
const PricingSection = dynamic(
    () =>
        import(
            'components/landingPageComponents/pricingSection/PricingSection'
        )
)
const LandingSection = dynamic(
    () =>
        import(
            'components/landingPageComponents/landingSection/LandingSection'
        )
)
const HorizentleSectionGallery = dynamic(
    () =>
        import(
            'components/landingPageComponents/horizentleGallerySection/HorizentleSectionGallery'
        )
)
const TestimonialSection = dynamic(
    () =>
        import(
            'components/landingPageComponents/testimonialSection/TestimonialSection'
        )
)

const default_value = 'Free Online Scheduling, Appointment, Booking and Business Management Software for Small to Medium-Sized Businesses - Always On Time'

// function Home () {

// }
function Home() {
    const { API_ENDPOINT, LANDING_PAGES_HOST} = getConfig().publicRuntimeConfig
    
    useEffect(() => {
        if (!API_ENDPOINT.includes('stg')) {
            document.location = LANDING_PAGES_HOST
        }
    }, [])
    const { translations, loadComponentTranslations } = useAppContext()
    const refs = {
        features: useRef(null),
        testimonials: useRef(null),
        pricing: useRef(null),
    }

    const executeScroll = () => {
        if (
            location.hash &&
            location.hash.substr(1) === 'features' &&
            refs.pricing.current
        ) {
            ; (refs.pricing.current as HTMLDivElement).scrollIntoView()
        }
        if (
            location.hash.substr(1) === 'testimonials' &&
            refs.testimonials.current
        ) {
            ; (refs.testimonials.current as HTMLDivElement).scrollIntoView()
        }
        if (
            location.hash.substr(1) === 'features' &&
            refs.features.current
        ) {
            ; (refs.features.current as HTMLDivElement).scrollIntoView()
        }
    }

    useEffect(() => {
        if (!translations.LANDING_TRANSLATION_ID) {
            loadComponentTranslations('LANDING_TRANSLATION_ID')
        }
    }, [translations])

    executeScroll()
    const chatRef = useRef<any>()

    return (
        <div>
            <Head>
                <title>
                    {translations.home_page_title || default_value}
                </title>
                <meta
                    name="description"
                    content={
                        translations.home_page_meta_description ||
                        default_value
                    }
                    key="description"
                />
                <meta
                    property="og:title"
                    content={translations.home_page_meta_title || default_value}
                    key="og:title"
                />
                <meta
                    property="og:description"
                    content={translations.home_page_meta_description ||
                        default_value
                    }
                    key="og:description"
                />
                <meta
                    property="og:image"
                    content="https://static.aot.plus/images/index_og_image.png"
                    key="og:image"
                />
                <meta
                    property="og:image:secure_url"
                    content="https://static.aot.plus/images/index_og_image.png"
                    key="og:image:secure_url"
                />
                {CanonicalLink()}
                <link rel="icon" href={tenant_logo_url} type="image/svg+xml"/>

                {/* <script
                    async
                    type="text/javascript"
                    defer
                    key={pathname}
                    ref={chatRef}
                    dangerouslySetInnerHTML={{
                        __html:
                            pathname == '/'
                                ? `var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
                            (function(){
                            var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                            s1.async=true;
                            s1.src='https://embed.tawk.to/624057362abe5b455fc1d67c/1fv5l9bnt';
                            s1.charset='UTF-8';
                            s1.setAttribute('crossorigin','*');
                            s0.parentNode.insertBefore(s1,s0);
                            })();`
                                : '<p></p>',
                    }}
                /> */}
            </Head>

            {!translations.LANDING_TRANSLATION_ID ? (
                <div className="h-venti w-full flex items-center bg-white animate-pulse">
                    <div className="h-4 bg-primary-lighter rounded block" />
                </div>
            ) : (
                <>
                    <Navbar />

                    <main className="overflow-hidden ">
                        <div
                            className="relative  h-1500 sm:h-1200 md:h-auto "
                        // style={{ height: '900px' }}
                        >
                            <div className="bg-[url('/images/landing_background.svg')] bg-no-repeat bg-cover  relative">
                                <LandingSection />
                            </div>
                        </div>

                        <Row>
                            <>
                                <div
                                    id="partners"
                                    style={{ marginTop: '142px' }}
                                >
                                    <LandingPartnersSection />
                                </div>
                                <SecondSection /> <ThirdSection />
                            </>
                        </Row>

                        <FourthSection />
                        <Row>
                            <div id="industries">
                                <GallerySection />
                            </div>
                        </Row>
                        <div className="h-auto sm:h-1300">
                            <div
                                ref={refs.testimonials}
                                id="testimonials"
                                className="pt-10 lg:pb-0 lg:h-1250 2xl:h-1250"
                                style={{
                                    background:
                                        'linear-gradient(59.02deg, #9358F7 -20.43%, #7B78F2 12.17%, #6197EE 42.42%, #45B5E9 75.81%, #10D7E2 105.12%)',
                                    borderRadius: '150px 0px',
                                }}
                            >
                                <TestimonialSection />
                                <ClientCards />
                            </div>
                        </div>
                        {/* <Row customClassName="xl:px-ten_percent"> */}
                        <AwardSection />
                        {/* </Row> */}

                        <div ref={refs.features} id="features" />
                        <Row customClassName="xl:px-ten_percent">
                            <FeaturesListSection />
                        </Row>
                        <div
                            ref={refs.pricing}
                            id="pricing"
                            className="w-full wide:w-1920-p mx-auto "
                        >
                            <PricingSection />
                        </div>
                        <div className="w-full wide:w-1920-p mx-auto mb-12">
                            <TeamSection />
                        </div>
                        <div>
                            <LandingSectionTryCTA />
                        </div>
                        <HorizentleSectionGallery />
                        {/* <div className="w-full wide:w-1920-p mx-auto"> */}
                        <Footer {...translations} />
                        {/* </div> */}
                    </main>
                </>
            )}

            {/* <LoginModal />
            <SignupModal /> */}
            <EmailVerificationModal />
        </div>
    )
}

export default Home

export const Row = ({
    children,
    customClassName = undefined,
}: {
    children: JSX.Element
    customClassName?: string | undefined
}) => (
    <div
        className={`px-5 lg:px-10 xl:px-fifteen_percent w-full wide:w-1920-p flex flex-col mx-auto ${customClassName}`}
    >
        {children}
    </div>
)

export const LANDING_IMAGES_BASE_URL =
    'https://static.aot.plus/images/landing-page/'
